/*
 * Your Hall  ·  My Party tab  ·  assets/hoh-hall-party.js
 *
 * Renders named parties: the player character roster the DM commissions
 * art for. Six slots per party. Drag to reorder. Tap empty slot to fill
 * from saved heroes. Color picker. Run Party hands the slotted heroes
 * to the existing Company tool. Commission CTA below filled parties
 * deep links into the FramedFantasy commission product.
 *
 * Public API:
 *   hohHallRenderParty(host)
 *
 * Reads:
 *   window.hohHallGet()                    party + hero data
 *   window.hohGetAllCharacters()           pool for portraits
 *   window.hohHallCreateParty / Update / Delete / SetPartySlot / ReorderPartySlots
 *   window.hohOpenDetail                   tap a filled slot to open detail
 *   window.hohOpenCompanyTool              Run Party path
 */
(function(){
  'use strict';

  function esc(s){
    if(s == null) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function partyColors(){
    return (window.HOH_HALL_PARTY_COLORS || ['gold','crimson','frost','green','purple','blue']).slice();
  }
  function partySize(){
    /* Cap party at 5 heroes. Standard D&D groups are 4–5 players (+
       the DM), and the Company tool's server cap is 5 — so 6-hero
       parties used to fail at company-gather time. Capping here
       keeps everything coherent: the slot grid renders 5, the picker
       only allows 5, and Run This Party hands the company exactly
       what it can process. */
    return Math.min(5, Number(window.HOH_HALL_PARTY_SIZE) || 5);
  }

  function pickerState(){
    /* Singleton picker state. We mount the modal once the first time it
       opens and reuse the node thereafter. */
    return window.__hohPartyPicker = window.__hohPartyPicker || { partyId: null, slotIdx: -1 };
  }

  function characterById(id){
    var pool = (typeof window.hohGetAllCharacters === 'function') ? (window.hohGetAllCharacters() || []) : [];
    for(var i=0;i<pool.length;i++){ if(pool[i] && pool[i].id === id) return pool[i]; }
    return null;
  }

  /* R104: Resolve a hero's rarity tier from heart count. Mirrors the
     ladder in hoh-section-core.js. Returns a tier key ('common',
     'uncommon', 'rare', 'epic', 'legendary', 'mythic') so the slot
     button can carry the matching border + name color. Defensive
     fallback if hohGetRarity is loaded — use the canonical helper. */
  function rarityTierForHero(c){
    if(!c) return 'common';
    if(typeof window.hohGetRarity === 'function'){
      try {
        var r = window.hohGetRarity(c.hearts || 0);
        if(r && r.tier) return r.tier;
      } catch(_){}
    }
    /* R769 ladder: 0/50/200/500/1000/1200, mirrors hohGetRarity */
    var n = c.hearts || 0;
    if(n >= 1200) return 'mythic';
    if(n >= 1000) return 'legendary';
    if(n >= 500) return 'epic';
    if(n >= 200) return 'rare';
    if(n >= 50) return 'uncommon';
    return 'common';
  }

  function slotPortraitHtml(heroId){
    if(!heroId) return '';
    var c = characterById(heroId);
    if(!c){
      return '<div class="hoh-party-slot-letter">?</div>';
    }
    var firstLetter = esc((c.name || '?').charAt(0));
    var img = c.image_thumb_url || c.image_url;
    var name = esc(c.name || 'Unnamed');
    var style = (typeof window.hohImgStyle === 'function') ? window.hohImgStyle(c.id, 'primary') : '';
    return (img
      ? '<img class="hoh-party-slot-img" src="' + esc(img) + '" alt="' + name + '" style="' + esc(style) + '" loading="lazy" decoding="async" crossorigin="anonymous">'
      : '<div class="hoh-party-slot-letter">' + firstLetter + '</div>') +
      '<div class="hoh-party-slot-name">' + name + '</div>';
  }

  function partyCardHtml(p){
    var slots = Array.isArray(p.slots) ? p.slots : new Array(partySize()).fill(null);
    var size = partySize();
    var slotsHtml = '';
    for(var i=0;i<size;i++){
      var heroId = slots[i] || null;
      var filled = !!heroId;
      /* R104: Tag the slot with the hero's rarity tier so the border
         and name color reflect community love (mirrors the rarity
         badge on the main hall card). Empty slots stay neutral. */
      var rarityCls = '';
      if(filled){
        var heroChar = characterById(heroId);
        rarityCls = ' hoh-party-slot-rar-' + rarityTierForHero(heroChar);
      }
      slotsHtml += '<button type="button" class="hoh-party-slot' + (filled ? ' hoh-party-slot-filled' : '') + rarityCls + '" data-party-id="' + esc(p.id) + '" data-slot-idx="' + i + '"' + (filled ? ' draggable="true"' : '') + '>' +
        (filled ? slotPortraitHtml(heroId) : '<span class="hoh-party-slot-add-icon">&plus;</span><span>Slot ' + (i+1) + '</span>') +
        (filled ? '<span class="hoh-party-slot-remove" data-act="remove-slot" data-party-id="' + esc(p.id) + '" data-slot-idx="' + i + '" aria-label="Remove from slot">&times;</span>' : '') +
      '</button>';
    }
    var colorRow = partyColors().map(function(col){
      var on = (p.color === col) ? ' hoh-party-color-on' : '';
      return '<button type="button" class="hoh-party-color-pick' + on + '" data-color="' + esc(col) + '" data-party-id="' + esc(p.id) + '" aria-label="' + esc(col) + '"></button>';
    }).join('');
    var filledCount = 0; for(var k=0;k<slots.length;k++) if(slots[k]) filledCount++;
    var canRun = filledCount >= 2;
    var runLabel = canRun ? 'Run This Party · ' + filledCount : 'Run This Party';
    var hint = canRun
      ? ''
      : '<span class="hoh-party-hint">Add ' + (2 - filledCount) + ' more hero' + (2 - filledCount === 1 ? '' : 'es') + ' to run.</span>';
    /* Inline onclick on the run button so it works even if the
       delegated host listener is in a stale state. window.hohRunPartyById
       is exposed below as the canonical entry point. */
    var safeId = String(p.id).replace(/'/g, "\\'");
    return '<div class="hoh-party-card hoh-party-color-' + esc(p.color || 'gold') + '" data-party-id="' + esc(p.id) + '">' +
      '<div class="hoh-party-head">' +
        '<input type="text" class="hoh-party-name-input" value="' + esc(p.name || 'My Party') + '" data-party-id="' + esc(p.id) + '" maxlength="40" aria-label="Party name">' +
        '<div class="hoh-party-color-row">' + colorRow + '</div>' +
      '</div>' +
      '<div class="hoh-party-slots" data-party-id="' + esc(p.id) + '">' + slotsHtml + '</div>' +
      '<div class="hoh-party-actions">' +
        '<button type="button" class="hoh-party-run-btn" data-party-id="' + esc(p.id) + '"' + (canRun ? '' : ' disabled') + ' onclick="if(window.hohRunPartyById)hohRunPartyById(\'' + safeId + '\')">' +
          '<span aria-hidden="true">&#9876;&#xFE0E;</span>' +
          '<span>' + runLabel + '</span>' +
        '</button>' +
        '<button type="button" class="hoh-party-delete-btn" data-party-id="' + esc(p.id) + '" data-act="delete-party">Delete</button>' +
        hint +
      '</div>' +
    '</div>';
  }

  /* Public entry for the Run This Party button. Called from inline
     onclick AND from the delegated host listener. Idempotent. */
  window.hohRunPartyById = function(partyId){
    if(!partyId) return;
    runParty(partyId);
  };

  function paint(host){
    var hall = (typeof window.hohHallGet === 'function') ? window.hohHallGet() : { parties: [] };
    var parties = hall.parties || [];
    var listHtml = parties.map(partyCardHtml).join('');
    /* R63: My Party intro — explains what this tab is FOR. The vision:
       D&D players bring their REAL party here (their character + their
       table-mates\' characters) and use the Company tool to see how
       the group plays off each other outside the session. The intro
       sells that idea so users build the right thing. */
    /* R78/R82: Consolidated single value-prop block. R82 dropped the
       redundant "MY PARTY" eyebrow — the user is already on the My
       Party tab so that label was repeating itself. Steps row is
       centered so it reads as a tidy 1-2-3 reference rather than a
       left-aligned wrap on narrow viewports. */
    var introHtml =
      '<div class="hoh-party-intro">' +
        '<div class="hoh-party-intro-title">Cast any party. Run any scenario.</div>' +
        /* R245: party pool is now the player\'s own submitted heroes plus the
           FramedFantasy cards they pulled from packs. Copy no longer promises
           "anyone from the hall" so the pitch matches what the picker allows. */
        '<div class="hoh-party-intro-body">' +
          'Mix the heroes you submitted with the FramedFantasy cards you pulled from packs and watch their backstories collide. ' +
          'Run your real D&amp;D crew through a one-shot. ' +
          'Bring two characters you played years apart together for the first time. ' +
          'Then throw the whole roster into a heist gone wrong.' +
        '</div>' +
        '<div class="hoh-party-intro-steps">' +
          '<span class="hoh-party-intro-step"><span class="hoh-party-intro-step-num">1</span>Build a party below.</span>' +
          '<span class="hoh-party-intro-step"><span class="hoh-party-intro-step-num">2</span>Pick a scenario.</span>' +
          '<span class="hoh-party-intro-step"><span class="hoh-party-intro-step-num">3</span>See what happens.</span>' +
        '</div>' +
      '</div>';
    host.innerHTML =
      introHtml +
      '<div class="hoh-yh-dash-section-title">Your Parties</div>' +
      (parties.length === 0
        ? '<div class="hoh-saved-empty"><strong>No parties yet.</strong><br>Build a party for the player characters at your table. Drag heroes from your hall into the slots, name the crew, then run it through the Company tool to generate a fresh group dynamic.</div>'
        : '<div class="hoh-party-list">' + listHtml + '</div>') +
      '<button type="button" class="hoh-party-create-btn" id="hoh-party-create-btn">' +
        '<span aria-hidden="true">&plus;</span>' +
        '<span>New Party</span>' +
      '</button>';

    /* Attach delegated host-level listeners ONCE per host lifetime.
       The slot containers themselves are fresh DOM each paint, so
       per-container listeners (drag reorder) attach cleanly. */
    if(!host.__hohPartyWired){
      host.__hohPartyWired = true;
      wirePartyActions(host);
      wireSlotInteractions(host);
    } else {
      /* Re-wire only the per-slot-container listeners (those nodes
         are new each paint). The host-level click/input handlers
         already exist from the first paint. */
      wirePerContainerListeners(host);
    }

    /* Subscribe so external changes (a hero removed from another tab,
       say) reflect here too. */
    if(window.__hohPartyUnsub){ try { window.__hohPartyUnsub(); } catch(_){} }
    if(typeof window.hohHallSubscribe === 'function'){
      window.__hohPartyUnsub = window.hohHallSubscribe(function(kind){
        if(!document.body.contains(host)) return;
        if(!document.querySelector('.hoh-party-list, .hoh-party-create-btn')) return;
        /* Avoid re-render storms when WE were the cause. The kinds
           emitted by our own writes are 'party-*'; gate on those plus
           hero-removed which can null a slot. */
        if(kind === 'party-created' || kind === 'party-deleted' || kind === 'hero-removed'){
          paint(host);
        }
      });
    }
  }

  function wirePartyActions(host){
    /* R75: Click delegation for ALL party actions, including the
       New Party button. The previous code attached a direct listener
       to #hoh-party-create-btn, which only worked for the FIRST
       paint — every subsequent paint() replaced the host\'s innerHTML,
       leaving the new button without a handler. On mobile after
       creating a party (which triggers a repaint), the New Party
       button became dead. Delegated handler on the host catches
       clicks bubbling from the button regardless of paint cycles. */
    host.addEventListener('click', function(e){
      var t = e.target;
      if(!t) return;
      /* New Party button — delegated. */
      var newBtn = t.closest && t.closest('#hoh-party-create-btn');
      if(newBtn){
        e.preventDefault();
        if(typeof window.hohHallCreateParty !== 'function') return;
        var hall = window.hohHallGet();
        var name = 'Party ' + ((hall.parties || []).length + 1);
        window.hohHallCreateParty(name, 'gold');
        paint(host);
        /* Focus the newly created party\'s name input for immediate
           rename. */
        setTimeout(function(){
          var inputs = host.querySelectorAll('.hoh-party-name-input');
          if(inputs.length){
            var last = inputs[inputs.length - 1];
            last.focus(); last.select();
          }
        }, 30);
        return;
      }
      var color = t.closest && t.closest('.hoh-party-color-pick');
      if(color){
        e.preventDefault();
        var partyId = color.getAttribute('data-party-id');
        var col = color.getAttribute('data-color');
        if(typeof window.hohHallUpdateParty === 'function'){
          window.hohHallUpdateParty(partyId, { color: col });
          paint(host);
        }
        return;
      }
      var del = t.closest && t.closest('[data-act="delete-party"]');
      if(del){
        e.preventDefault();
        var pid = del.getAttribute('data-party-id');
        var hall = window.hohHallGet();
        var p = (hall.parties || []).find(function(x){ return x.id === pid; });
        var label = (p && p.name) ? ('"' + p.name + '"') : 'this party';
        if(window.confirm('Delete ' + label + '? This cannot be undone.')){
          if(typeof window.hohHallDeleteParty === 'function'){
            window.hohHallDeleteParty(pid);
            paint(host);
          }
        }
        return;
      }
      var removeSlot = t.closest && t.closest('[data-act="remove-slot"]');
      if(removeSlot){
        e.preventDefault(); e.stopPropagation();
        var rpid = removeSlot.getAttribute('data-party-id');
        var rsi = parseInt(removeSlot.getAttribute('data-slot-idx'), 10);
        if(typeof window.hohHallSetPartySlot === 'function'){
          window.hohHallSetPartySlot(rpid, rsi, null);
          paint(host);
        }
        return;
      }
      var run = t.closest && t.closest('.hoh-party-run-btn');
      if(run && !run.disabled){
        e.preventDefault();
        var rpid2 = run.getAttribute('data-party-id');
        runParty(rpid2);
        return;
      }
    });

    /* Name editing. */
    host.addEventListener('input', function(e){
      var t = e.target;
      if(!t || !t.classList || !t.classList.contains('hoh-party-name-input')) return;
      var pid = t.getAttribute('data-party-id');
      if(!pid) return;
      /* Throttle to once-per-200ms via a per-input timer. */
      clearTimeout(t.__t);
      t.__t = setTimeout(function(){
        if(typeof window.hohHallUpdateParty === 'function'){
          window.hohHallUpdateParty(pid, { name: t.value });
        }
      }, 200);
    });
  }

  function wireSlotInteractions(host){
    /* Tap empty slot → open hero picker. Tap filled slot (not on the
       remove-x corner) → open detail modal. Delegated to host so we
       only attach once. */
    host.addEventListener('click', function(e){
      var slot = e.target.closest && e.target.closest('.hoh-party-slot');
      if(!slot) return;
      /* The remove-x corner has its own handler in wirePartyActions,
         and stopPropagation there prevents this from firing. */
      var partyId = slot.getAttribute('data-party-id');
      var slotIdx = parseInt(slot.getAttribute('data-slot-idx'), 10);
      var filled = slot.classList.contains('hoh-party-slot-filled');
      if(!filled){
        /* Open picker. */
        openHeroPicker(host, partyId, slotIdx);
        return;
      }
      /* Filled: open detail modal for the hero in this slot. */
      var hall = window.hohHallGet();
      var party = (hall.parties || []).find(function(p){ return p.id === partyId; });
      if(!party) return;
      var heroId = party.slots && party.slots[slotIdx];
      if(heroId && typeof window.hohOpenDetail === 'function') window.hohOpenDetail(heroId);
    });

    wirePerContainerListeners(host);
  }

  /* Drag listeners that must attach to slot containers (the containers
     themselves are recreated on each paint, so re-attaching is correct
     and not a leak). Extracted so the wired-once host can still pick
     up new containers on subsequent paints. */
  function wirePerContainerListeners(host){
    var slotsContainers = host.querySelectorAll('.hoh-party-slots');
    slotsContainers.forEach(function(cont){
      if(cont.__hohPartyContWired) return;
      cont.__hohPartyContWired = true;
      var dragEl = null;
      cont.addEventListener('dragstart', function(e){
        var s = e.target.closest && e.target.closest('.hoh-party-slot.hoh-party-slot-filled');
        if(!s){ e.preventDefault(); return; }
        dragEl = s;
        s.classList.add('hoh-party-slot-dragging');
        try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', s.getAttribute('data-slot-idx') || ''); } catch(_){}
      });
      cont.addEventListener('dragover', function(e){
        if(!dragEl) return;
        e.preventDefault();
        var hit = e.target.closest && e.target.closest('.hoh-party-slot');
        if(!hit || hit === dragEl) return;
        var rect = hit.getBoundingClientRect();
        var midX = rect.left + rect.width / 2;
        var before = e.clientX < midX;
        if(before){
          if(hit.previousElementSibling !== dragEl) cont.insertBefore(dragEl, hit);
        } else {
          if(hit.nextElementSibling !== dragEl) cont.insertBefore(dragEl, hit.nextElementSibling);
        }
      });
      cont.addEventListener('dragend', function(){
        if(!dragEl) return;
        dragEl.classList.remove('hoh-party-slot-dragging');
        commitSlotOrder(cont);
        dragEl = null;
      });

      /* Mobile slot reorder: long-press to grab, drag, release.
         Wired on the same container as desktop DnD; guard above
         prevents double attach. */
      var pressTimer = null;
      var touchDragEl = null;
      cont.addEventListener('pointerdown', function(e){
        if(e.pointerType !== 'touch') return;
        var s = e.target.closest && e.target.closest('.hoh-party-slot.hoh-party-slot-filled');
        if(!s) return;
        if(e.target.closest && e.target.closest('.hoh-party-slot-remove')) return;
        pressTimer = setTimeout(function(){
          touchDragEl = s;
          s.classList.add('hoh-party-slot-dragging');
          try { s.setPointerCapture && s.setPointerCapture(e.pointerId); } catch(_){}
        }, 350);
      });
      cont.addEventListener('pointermove', function(e){
        if(!touchDragEl || e.pointerType !== 'touch') return;
        var el = document.elementFromPoint(e.clientX, e.clientY);
        var hit = el && el.closest && el.closest('.hoh-party-slot');
        if(!hit || hit === touchDragEl) return;
        var rect = hit.getBoundingClientRect();
        var midX = rect.left + rect.width / 2;
        var before = e.clientX < midX;
        if(before){
          if(hit.previousElementSibling !== touchDragEl) cont.insertBefore(touchDragEl, hit);
        } else {
          if(hit.nextElementSibling !== touchDragEl) cont.insertBefore(touchDragEl, hit.nextElementSibling);
        }
      }, { passive: true });
      cont.addEventListener('pointerup', function(){
        clearTimeout(pressTimer);
        if(touchDragEl){
          touchDragEl.classList.remove('hoh-party-slot-dragging');
          commitSlotOrder(cont);
          touchDragEl = null;
        }
      });
      cont.addEventListener('pointercancel', function(){
        clearTimeout(pressTimer);
        if(touchDragEl){
          touchDragEl.classList.remove('hoh-party-slot-dragging');
          touchDragEl = null;
        }
      });
    });
  }

  function commitSlotOrder(cont){
    var partyId = cont.getAttribute('data-party-id');
    var slots = cont.querySelectorAll('.hoh-party-slot');
    var ids = [];
    var hall = window.hohHallGet();
    var party = (hall.parties || []).find(function(p){ return p.id === partyId; });
    if(!party) return;
    /* Each slot may be filled or empty. Read from current DOM order
       and pull the actual hero ids from the party data using each
       slot's original data-slot-idx. */
    var slotsArr = Array.from(slots);
    var orderedHeroIds = slotsArr.map(function(el){
      var idx = parseInt(el.getAttribute('data-slot-idx'), 10);
      var heroId = party.slots && party.slots[idx];
      return heroId || null;
    });
    if(typeof window.hohHallReorderPartySlots === 'function'){
      window.hohHallReorderPartySlots(partyId, orderedHeroIds);
      /* Update the data-slot-idx attributes to match the new order
         so the next drag reads from the new positions. */
      var host = cont.closest('.hoh-yh-tab-content') || document.getElementById('hoh-yh-tab-content');
      if(host) paint(host);
    }
  }

  function runParty(partyId){
    var hall = window.hohHallGet();
    var party = (hall.parties || []).find(function(p){ return p.id === partyId; });
    if(!party) return;
    var ids = (party.slots || []).filter(Boolean);
    if(ids.length < 2) return;
    /* One-shot exact-member run. The Company tool detects exact:true
       and skips the size picker (size = memberIds.length). Cleared
       by the tool after a successful generation. */
    window.__hohPendingPartyRun = { partyId: partyId, memberIds: ids.slice(), exact: true };
    if(typeof window.hohHallUpdateParty === 'function'){
      window.hohHallUpdateParty(partyId, { lastRunAt: Date.now() });
    }
    /* Open the Company modal as an overlay on top of Your Hall. The
       modal has higher z-index than #hoh-yh-page, so we don't need
       to switch page modes. The Company tool reads
       __hohPendingPartyRun and skips the size picker. */
    if(typeof window.hohOpenCompanyTool === 'function') window.hohOpenCompanyTool();
  }

  /* ------------------------------------------------------------------ */
  /* Hero picker modal                                                  */
  /* ------------------------------------------------------------------ */

  /* Picker filter state. Three independent toggles let the user
     mix and match where heroes come from: their submitted characters,
     their hearted heroes, and their saved favorites. All three default
     ON so a new user sees the broadest pool. The user narrows with
     checkboxes + the search field. */
  /* R245: a party is built only from what the user owns — their submitted
     heroes and the FramedFantasy cards they collected from packs. The
     Hearted and Favorites sources (other players' characters) are gone. */
  var PICKER_FILTERS = { heroes: true, packcards: true };

  function ensurePicker(){
    var m = document.getElementById('hoh-hero-picker-modal');
    if(m) return m;
    m = document.createElement('div');
    m.id = 'hoh-hero-picker-modal';
    m.className = 'hoh-hero-picker-modal';
    m.innerHTML =
      '<div class="hoh-hero-picker-content" role="dialog" aria-label="Pick a hero">' +
        '<div class="hoh-hero-picker-head">' +
          '<div class="hoh-hero-picker-title">Pick a hero</div>' +
          '<button type="button" class="hoh-hero-picker-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<input type="text" class="hoh-hero-picker-search" placeholder="Search your heroes...">' +
        '<div class="hoh-hero-picker-filters">' +
          '<label class="hoh-hero-picker-filter">' +
            '<input type="checkbox" class="hoh-hero-picker-filter-input" data-pf="heroes" checked>' +
            '<span class="hoh-hero-picker-filter-label">My Heroes</span>' +
            '<span class="hoh-hero-picker-filter-sub">Submitted</span>' +
          '</label>' +
          '<label class="hoh-hero-picker-filter">' +
            '<input type="checkbox" class="hoh-hero-picker-filter-input" data-pf="packcards" checked>' +
            '<span class="hoh-hero-picker-filter-label">Pack Cards</span>' +
            '<span class="hoh-hero-picker-filter-sub">Collected</span>' +
          '</label>' +
        '</div>' +
        '<div class="hoh-hero-picker-grid"></div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e){
      if(e.target === m) closePicker();
    });
    m.querySelector('.hoh-hero-picker-close').addEventListener('click', closePicker);
    m.querySelector('.hoh-hero-picker-search').addEventListener('input', function(e){
      paintPicker(e.target.value);
    });
    /* Wire each filter checkbox to update PICKER_FILTERS and re-render
       the grid in place. The filter row sits ABOVE the grid so the
       user always sees what's currently included. */
    m.querySelectorAll('.hoh-hero-picker-filter-input').forEach(function(cb){
      cb.addEventListener('change', function(){
        var key = cb.getAttribute('data-pf');
        if(key) PICKER_FILTERS[key] = !!cb.checked;
        var search = m.querySelector('.hoh-hero-picker-search');
        paintPicker(search ? search.value : '');
      });
    });
    return m;
  }

  function openHeroPicker(host, partyId, slotIdx, options){
    /* R77: Added options.onPick callback mode. When provided, the
       picker calls onPick(heroId) instead of writing to a party slot.
       The Company form\'s "Add Member" button uses this so it can
       extend the in-flight party without touching saved party data.
       options.excludeIds is an optional array of hero IDs to gray out
       (e.g. heroes already in the in-flight company party). */
    var m = ensurePicker();
    var st = pickerState();
    st.partyId = partyId;
    st.slotIdx = slotIdx;
    st.host = host;
    st.onPick = (options && typeof options.onPick === 'function') ? options.onPick : null;
    st.excludeIds = (options && Array.isArray(options.excludeIds)) ? options.excludeIds.slice() : [];
    m.classList.add('hoh-hero-picker-on');
    var search = m.querySelector('.hoh-hero-picker-search');
    if(search) search.value = '';
    paintPicker('');
    /* R245: make sure the collected pack cards are loaded, then repaint so
       they appear even if the Shop tab was never opened this session. */
    try {
      if(typeof window.hohShopEnsureState === 'function'){
        window.hohShopEnsureState().then(function(){
          var s = m.querySelector('.hoh-hero-picker-search');
          if(m.classList.contains('hoh-hero-picker-on')) paintPicker(s ? s.value : '');
        });
      }
    } catch(_){}
    /* Focus search after the sheet animation. */
    setTimeout(function(){
      var s = m.querySelector('.hoh-hero-picker-search');
      if(s) s.focus();
    }, 60);
    document.body.style.overflow = 'hidden';
  }
  /* R77: Public entry for callers outside this module (the Company
     form). Accepts a callback and optional list of already-included
     hero IDs. */
  window.hohHallOpenHeroPicker = function(opts){
    opts = opts || {};
    openHeroPicker(null, null, -1, {
      onPick: opts.onPick,
      excludeIds: opts.excludeIds
    });
  };

  function closePicker(){
    var m = document.getElementById('hoh-hero-picker-modal');
    if(!m) return;
    m.classList.remove('hoh-hero-picker-on');
    document.body.style.overflow = '';
    var st = pickerState();
    st.partyId = null; st.slotIdx = -1;
    st.onPick = null;
    st.excludeIds = [];
  }

  function paintPicker(query){
    var m = document.getElementById('hoh-hero-picker-modal');
    if(!m) return;
    var grid = m.querySelector('.hoh-hero-picker-grid');
    if(!grid) return;
    var hall = (typeof window.hohHallGet === 'function') ? window.hohHallGet() : { heroes: [] };
    var heroes = hall.heroes || [];
    var pool = (typeof window.hohGetAllCharacters === 'function') ? (window.hohGetAllCharacters() || []) : [];
    var byId = {}; for(var i=0;i<pool.length;i++){ if(pool[i] && pool[i].id) byId[pool[i].id] = pool[i]; }

    /* R245: two sources combine to populate the picker — gated by the
       per-source filter checkboxes:
         heroes    → user's own submitted characters (auth_email
                     matches hohYourHallEmail)
         packcards → FramedFantasy cards the user pulled from Shop packs
                     (window.hohShopOwnedCards)
       Other players' hearted or favorited characters are no longer
       eligible: a party is built only from what the player owns. */
    var ownEmail = (typeof window.hohYourHallEmail === 'function') ? String(window.hohYourHallEmail() || '').toLowerCase() : '';
    var ownChars = ownEmail ? pool.filter(function(c){ return c && c.auth_email && String(c.auth_email).toLowerCase() === ownEmail; }) : [];

    var heartMap = {};
    try {
      var rawH = localStorage.getItem('hoh-hearts');
      if(rawH) heartMap = JSON.parse(rawH) || {};
    } catch(_){}
    var heartedChars = Object.keys(heartMap)
      .filter(function(id){ return (heartMap[id] || 0) > 0; })
      .map(function(id){ return byId[id]; })
      .filter(Boolean);

    /* Already filled in this party (so we can dim them). */
    var st = pickerState();
    var party = (hall.parties || []).find(function(p){ return p.id === st.partyId; });
    var alreadyInThisParty = {};
    if(party && Array.isArray(party.slots)){
      for(var k=0;k<party.slots.length;k++){
        if(party.slots[k] && k !== st.slotIdx) alreadyInThisParty[party.slots[k]] = true;
      }
    }
    /* R77: In callback mode (Company form Add Member), exclude heroes
       already in the in-flight company party so the user can\'t add
       a duplicate. */
    if(st.excludeIds && st.excludeIds.length){
      st.excludeIds.forEach(function(id){ if(id) alreadyInThisParty[id] = true; });
    }

    /* Combine sources based on filter state. Dedup by id. */
    var seen = {};
    var combined = [];
    function pushCard(c){
      if(!c || !c.id || seen[c.id]) return;
      seen[c.id] = true;
      combined.push(c);
    }
    /* R245: pool is own submitted heroes + collected pack cards only. Other
       players' hearted or favorited characters are no longer eligible. */
    var packCards = (typeof window.hohShopOwnedCards === 'function') ? (window.hohShopOwnedCards() || []) : [];
    if(PICKER_FILTERS.heroes){
      ownChars.forEach(pushCard);
    }
    if(PICKER_FILTERS.packcards){
      packCards.forEach(pushCard);
    }

    var q = (query || '').trim().toLowerCase();
    if(q){
      combined = combined.filter(function(c){
        var hay = ((c.name || '') + ' ' + (c.race || '') + ' ' + (c.character_class || '')).toLowerCase();
        return hay.indexOf(q) !== -1;
      });
    }

    if(combined.length === 0){
      grid.innerHTML = '<div class="hoh-hero-picker-empty">No heroes yet. Submit your own heroes, or open packs in the Shop to collect FramedFantasy cards to build with.</div>';
      return;
    }

    /* Picker cards. Inline style="height:..." on the image and letter
       guarantees rendering regardless of any external CSS rule. Inline
       styles win over external CSS unless the external rule uses
       !important — and we test for desktop vs mobile width so the size
       feels right on each. Heights are tuned so vertical character
       portraits display in full via object-fit:contain without being
       cropped at the head or feet. */
    /* R246: portrait tiles use object-fit:cover with a slight top bias so the
       character fills the frame (was contain, which letterboxed every hero in
       black bars and read as broken thumbnails). Height gives a ~3:4 portrait. */
    var picH = (window.innerWidth >= 769) ? 168 : 200;
    grid.innerHTML = combined.map(function(c){
      var imgUrl = c.image_thumb_url || c.image_url;
      var firstLetter = esc((c.name || '?').charAt(0));
      /* R265: honor the saved reframe instead of a fixed top-bias crop, so the
         hero picker frames each portrait the same way every other grid does.
         Falls back to the old 50% 18% bias only if the shared getter is absent. */
      var pickPos = (typeof window.hohImgObjPos === 'function') ? window.hohImgObjPos(c.id, 'primary') : '50% 18%';
      var pickStyle = (typeof window.hohImgStyle === 'function') ? window.hohImgStyle(c.id, 'primary') : ('object-position:' + pickPos + ';');
      var portrait = imgUrl
        ? '<img class="hoh-hero-picker-img" data-hero-id="' + esc(c.id) + '" style="display:block;width:100%;height:' + picH + 'px;object-fit:cover;' + pickStyle + 'background:#0a0a0f;" src="' + esc(imgUrl) + '" alt="' + esc(c.name || '') + '" loading="lazy" decoding="async" crossorigin="anonymous">'
        : '<div class="hoh-hero-picker-letter" style="display:flex;align-items:center;justify-content:center;width:100%;height:' + picH + 'px;background:#0a0a0f;font-size:48px;color:rgba(200,164,94,0.6);font-family:Cinzel,serif;">' + firstLetter + '</div>';
      var already = !!alreadyInThisParty[c.id];
      var dim = already ? ' hoh-hero-picker-already' : '';
      var meta = ((c.race || '') + (c.character_class ? ' ' + c.character_class : '')).trim();
      return '<div role="button" tabindex="' + (already ? '-1' : '0') + '" class="hoh-hero-picker-card' + dim + '" data-pick-id="' + esc(c.id) + '"' + (already ? ' aria-disabled="true" aria-label="Already in this party"' : ' aria-label="Pick ' + esc(c.name || 'hero') + '"') + '>' +
        portrait +
        '<div class="hoh-hero-picker-name">' + esc(c.name || 'Unnamed') + '</div>' +
        (meta ? '<div class="hoh-hero-picker-meta">' + esc(meta) + '</div>' : '') +
      '</div>';
    }).join('');

    /* Click + keyboard handler. The picker cards are div role="button"
       so we restore button-like keyboard semantics: Enter and Space
       fire the same action as a click. aria-disabled blocks the
       handler for already-in-party heroes. */
    function pickHero(target){
      if(!target) return;
      if(target.getAttribute('aria-disabled') === 'true') return;
      var heroId = target.getAttribute('data-pick-id');
      if(!heroId) return;
      var stp = pickerState();
      /* R77: Callback mode (Company form Add Member). When onPick is
         set, just hand off the heroId and close — the caller handles
         what to do with it (no party slot write). */
      if(typeof stp.onPick === 'function'){
        try { stp.onPick(heroId); } catch(_){}
        closePicker();
        return;
      }
      if(!stp.partyId) return;
      if(typeof window.hohHallSetPartySlot === 'function'){
        window.hohHallSetPartySlot(stp.partyId, stp.slotIdx, heroId);
      }
      closePicker();
      /* R245: prefer the scoped Satchel party container so a re-paint
         never clobbers the surrounding Satchel tools and Saved Rolls. */
      var host = stp.host || document.getElementById('hoh-satchel-party') || document.getElementById('hoh-yh-tab-content');
      if(host) paint(host);
    }
    grid.onclick = function(e){
      var card = e.target.closest && e.target.closest('[data-pick-id]');
      pickHero(card);
    };
    grid.onkeydown = function(e){
      if(e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('[data-pick-id]');
      if(!card) return;
      e.preventDefault();
      pickHero(card);
    };
  }

  /* Esc closes the picker. */
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var m = document.getElementById('hoh-hero-picker-modal');
    if(m && m.classList.contains('hoh-hero-picker-on')) closePicker();
  });

  /* ------------------------------------------------------------------ */
  /* Public entry                                                       */
  /* ------------------------------------------------------------------ */

  window.hohHallRenderParty = function(host){
    if(!host) return;
    paint(host);
  };

  /* Re-render when the section signals characters are now loaded so
     slot portraits resolve. */
  document.addEventListener('hoh:characters-loaded', function(){
    /* R245: the party builder lives inside the Satchel at
       #hoh-satchel-party now. Re-paint ONLY that container so freshly
       loaded slot portraits resolve without wiping the Satchel tools and
       Saved Rolls that share the tab host. */
    var pc = document.getElementById('hoh-satchel-party');
    if(pc){ paint(pc); return; }
    /* Legacy fallback: a standalone party mount, kept for any deep link
       that still renders the party directly into the tab host. */
    var host = document.getElementById('hoh-yh-tab-content');
    if(host && host.querySelector('.hoh-party-list, .hoh-party-create-btn')) paint(host);
  });
})();
